export function filterValid<T>(selected: T[], options: { key: T }[]): T[] {
  const valid = options.map(o => o.key);
  return selected.filter(item => valid.includes(item));
}
